module.exports = __webpack_public_path__ + "img/mergeShape1.439bd8a9.png";